import { render, staticRenderFns } from "./additional-rewards.vue?vue&type=template&id=928c960a&scoped=true"
import script from "./additional-rewards.vue?vue&type=script&lang=js"
export * from "./additional-rewards.vue?vue&type=script&lang=js"
import style0 from "./additional-rewards.vue?vue&type=style&index=0&id=928c960a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928c960a",
  null
  
)

export default component.exports